/*
 * @Author: along longwang6@163.com
 * @Date: 2026-06-12 16:35:02
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2026-06-18 15:02:13
 * @FilePath: /ehr-web/src/utils/todoPanelLayout.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const TODO_PANEL_WIDTH = 500;
export const TODO_PANEL_TRANSITION_DURATION = 320;
export const TODO_PANEL_NAVIGATION_STATE = { fromTodoPanel: true };

/** 主内容区尺寸变化（待办面板开合、侧栏折叠等）时派发，供 useTableScrollY 重算表格高度 */
export const LAYOUT_CONTENT_RESIZE_EVENT = 'ehr-layout-content-resize';

export const dispatchLayoutContentResize = () => {
  window.dispatchEvent(new Event(LAYOUT_CONTENT_RESIZE_EVENT));
};

export const getCollapsedAfterTodoPanelOpen = () => {
  return true;
};

export const getCollapsedAfterTodoPanelClose = (
  collapsedBeforeOpen: boolean
) => {
  return collapsedBeforeOpen;
};

export const isTodoPanelNavigationState = (state: unknown) => {
  return (
    !!state &&
    typeof state === 'object' &&
    (state as { fromTodoPanel?: unknown }).fromTodoPanel === true
  );
};
